/**
 * Left-nav scroll position across page loads.
 *
 * Each route group (signed-in, admin, news, modules) mounts its own
 * Layout, so the Sidebar remounts when navigating between them. The
 * position is kept here, outside React, and restored on mount; then the
 * current page's link is brought into view if it isn't already.
 */

let rememberedScrollTop = 0;

/** Space left between a revealed link and the nav's edge, in px. */
const EDGE_PADDING = 8;

export function rememberNavScroll(nav: HTMLElement): void {
  rememberedScrollTop = nav.scrollTop;
}

export function restoreNavScroll(nav: HTMLElement): void {
  nav.scrollTop = rememberedScrollTop;
}

/**
 * Scroll `nav` the least needed to show the current page's link
 * (`aria-current="page"`, set by NavLink). No-op when one is in view.
 */
export function revealCurrentLink(nav: HTMLElement): void {
  const links = Array.from(nav.querySelectorAll<HTMLElement>('[aria-current="page"]'));
  if (links.length === 0) return;
  const box = nav.getBoundingClientRect();
  const inView = (link: HTMLElement) => {
    const rect = link.getBoundingClientRect();
    return rect.top >= box.top && rect.bottom <= box.bottom;
  };
  if (links.some(inView)) return;
  const rect = links[0]!.getBoundingClientRect();
  nav.scrollTop += rect.top < box.top
    ? rect.top - box.top - EDGE_PADDING
    : rect.bottom - box.bottom + EDGE_PADDING;
}
